<template>
  <ul class="crumb">
    <li
      v-for="crumb in crumb"
      :key="crumb.label"
      class="crumb__item"
    >
      <router-link
        v-if="!isLastCrumb(crumb)"
        :to="crumb.route" 
        class="crumb__link"
      >
        <span v-if="crumb.route.name == 'home'"> 
          <HomeSVG />
        </span>
        <span v-else>
          {{ crumb.label }}
        </span>
      </router-link>

      <span
        v-else
        class="crumb__text"
      >{{ crumb.label }}</span>
    </li>
  </ul>
</template>

<script>
  import HomeSVG from '@/components/svg/HomeSVG'

  export default {
    components: {
      HomeSVG
    },

    props: {
      crumb: { type: Array, default: () => ([]) }
    },

    computed: {
      isLastCrumb () {
        return (crumb) => this.crumb.slice(-1)[0].label == crumb.label
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .crumb {
    $p: &;

    display: flex;
    margin-bottom: 30px;
    text-transform: lowercase;

    &__item {
      position: relative;

      &:not(:last-child) {
        padding-right: 30px;

        &:after {
          content: '>';
          font-family: monospace;
          position: absolute;
          width: 0;
          height: 0;
          top: 2px;
          right: 19px;
          color: $white20;
        }
      }
    }

    &__text {
      font-size: 0.89rem;
      color: $white300;
    }

    &__link {
      @extend #{$p}__text;

      &:hover {
        color: #ff8800;
        text-decoration: underline !important;
      }
    }

    @media (max-width: 550px) {
      display: none;
    }
  }
</style>